import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './WhatWeDo.css'; // New or merged CSS file

gsap.registerPlugin(ScrollTrigger);

const servicesList = [
  "DESIGN",
  "BRANDING",
  "STRATEGY",
  "MARKETING",
  "IDENTITY",
  // Add more services
];

const repeatText = (text, times = 8) => { // May need fewer repeats depending on font/size
    return (` ${text.toUpperCase()} `).repeat(times).trim();
};

const CombinedMarqueeFill = () => {
  const sectionRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
     if (!sectionRef.current || !containerRef.current) return;

    let ctx = gsap.context(() => {
      const lines = gsap.utils.toArray('.marquee-fill-content'); // Target text content spans

      if(lines.length === 0) return;

      // Define animation properties dynamically
      const getAnimProps = (line, index) => {
        const isEven = index % 2 === 0;
        const moveDistance = line.offsetWidth * 0.2; // Horizontal marquee movement distance (adjust %)

        return {
          // --- Background Fill ---
          // Even (LTR fill): Target 100% (starts at 0% via CSS)
          // Odd (RTL fill): Target 0% (starts at 100% via CSS)
          bgPosXTarget: isEven ? '100%' : '0%',

          // --- Marquee Movement ---
          // Even (Move L): Target negative distance
          // Odd (Move R): Target positive distance
          xMoveTarget: isEven ? -moveDistance : moveDistance,
        };
      };

      // Single ScrollTrigger controls multiple animations via .to() tweens
      const tl = gsap.timeline({ // Use a timeline for better control if needed later, though individual tweens work too
        scrollTrigger: {
            trigger: containerRef.current,
            start: 'top 85%',
            end: 'bottom 15%',
            scrub: 1.8, // Smooth scrub for both animations
            // markers: process.env.NODE_ENV === 'development',
          },
      });

      lines.forEach((line, index) => {
         const props = getAnimProps(line, index);

         // Add both animations to the timeline, occurring simultaneously
         tl.to(line, {
             backgroundPositionX: props.bgPosXTarget, // Animate background fill
             ease: 'none' // MUST be linear for scrub
            },
           0 // Start both animations at the same time on the timeline (time=0)
         );

         tl.to(line, {
             x: props.xMoveTarget, // Animate horizontal position
             ease: 'none'
            },
           0 // Start both animations at the same time on the timeline
         );
      });

    }, sectionRef); // Scope context to the section

    // Cleanup
    return () => ctx.revert();

  }, []);

  return (
    <section className="what-we-do-section pro-elegant-light" ref={sectionRef}>
      <div className="container">
        {/* <h2 className="section-title pro-title">What We Do</h2> */}
        <div className="marquee-fill-container" ref={containerRef}>
          {servicesList.map((text, index) => (
            // Line wrapper for masking
            <div className="marquee-fill-wrapper" key={index}>
              {/* Content span holds the text, gradient, and moves */}
              <span
                 className={`marquee-fill-content ${index % 2 === 0 ? 'even-line' : 'odd-line'}`}
                 aria-hidden="true"
              >
                {repeatText(text)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CombinedMarqueeFill;